<div class="container">
  <div class="row">
    <div class="col-3"></div>
    <div class="col">
      <swiper #content [pagination]="paginationOptions" [speed]="350" [allowTouchMove]="false" [slidesPerView]="1" [virtual]="true">
        <ng-template *ngFor="let item of items; index as index" swiperSlide>
          <div class="container">
          <div class="boxHeader d-flex justify-content-between mt-3">
            <div class="icon-warning d-flex m-3">
              <span class="material-icons me-2">
                  {{item.icon}}
              </span>
              <p>{{item.textIcon}}</p>
            </div>
            <span class="material-icons icon-close m-3" mat-dialog-close>
              close
            </span>
          </div>
      
            <img [src]="item.image" alt="Print de tela">
            <div class="content">
              
              <h2 class="text-center">
                <div class="box-title d-flex align-items-center justify-content-center">
                  <h5 *ngIf="items.length>1">{{ index + 1 }}.</h5>
                  <h5 *ngIf="item.title">{{ item.title }}</h5>
                </div>
                <p *ngIf="item.text">{{ item.text }}</p>
              </h2>
      
              <div class="footer align-center justify-content-center">
                <button *ngIf="index > 0" color="white" mat-button (click)="goToSlide(index - 1)" class="BtnBorder BtnCarrosselBefore text-center align-middle p-0">
                  <span class="material-icons">west</span>
                </button>
      
                <button *ngIf="index &lt; (items.length - 1)" mat-button (click)="goToSlide(index + 1)" class="Btn BtnBorder BtnCarrosselAfter">
                  Próximo <span class="material-icons">east</span>
                </button>
      
                <button *ngIf="index === (items.length - 1) && items.length>1" mat-button (click)="handleSubmitEvent()" class=" Btn BtnPadrao BtnCarrosselAfter">
                  {{ submitText }}
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </swiper>
    </div>
    <div class="col-3"></div>
  </div>
</div>